<template>
    <div class="container mt-3">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="place">Seleccionar recinto</label>
                    <multiselect v-model="place" placeholder="Seleccionar recinto" label="name" track-by="id"
                                 :options="places" :multiple="false"
                    />
                </div>
            </div>
        </div>
        <div class="row mb-5">
            <div class="col-12 row" v-if="!loading_zonas && place">
                <CleSvgComponent v-if="zonas.length > 0" class="col-8" :zonas="zonas" :place="place"
                                 @clickZona="irAZona"
                />
                <TablaSectoresComponent class="col-4" v-if="zonas.length > 0" :zonas="zonas" @goTo="selectZonaTable" />
            </div>
            <div v-if="loading_zonas" class="col-12 text-center" style="height: 150px">
                <LoaderComponent/>
            </div>
        </div>
        <template v-if="zona">
            <div class="row">
                <div class="col-12">
                    <h1>Ocultar butacas</h1>
                    <h3>Zona: {{ zona.name }}</h3>
                </div>
                <div class="col-12">
                    <TerrenoJuegoComponent :direccion_campo="zona.direccion_campo" />
                    <div class="card card-primary card-outline card-outline-tabs mb-3">
                        <div class="card-header">
                            <ul class="nav nav nav-pills card-header-pills" role="tablist">
                                <li class="nav-item">
                                    <a href="#" :class="mode === 1 ? 'nav-link active-gray' : 'nav-link'"
                                       @click.prevent="mode = 1"
                                    >
                                        Ocultar butacas
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a href="#" :class="mode === 2 ? 'nav-link active-blue' : 'nav-link'"
                                       @click.prevent="mode = 2"
                                    >
                                        Añadir pasillo (Siguiendo con la numeración)
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a href="#" :class="mode === 3 ? 'nav-link active-red' : 'nav-link'"
                                       @click.prevent="mode = 3"
                                    >
                                        Añadir pasillo (Saltando la numeración)
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a href="#" :class="mode === 4 ? 'nav-link active-green' : 'nav-link'"
                                       @click.prevent="mode = 4"
                                    >
                                        Liberar butacas
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="card-body">
                            <div v-if="!loading_butacas">
                                <div id="container-butacas" class="container-butacas-wrapper hidden-seats noselect">
                                    <div :class="'container-butacas text-align-' + zona.print_align">
                                        <span v-for="(butacas, fila) in filas" :key="fila">
                                            <span class="fila">{{ fila }}</span>
                                            <template>
                                                <AsientoComponent v-for="(asiento, index) in butacas"
                                                                  class="ocultarButaca" :id="asiento.idUnico" :asiento="asiento"
                                                                  :fila="fila" :key="index + '_2'"
                                                />
                                            </template>
                                            <br />
                                        </span>
                                    </div>
                                </div>
                                <button class="btn w-auto float-right" @click="ocultarButacas">Ocultar butacas</button>
                            </div>
                            <div v-else>
                                <LoaderComponent/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="row mb-3">
                        <div class="col-12 d-flex align-items-center">
                            <span class="dot-gris"></span>
                            <span>Butaca oculta (No se muestra la butaca ni se respeta el hueco)</span>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-12 d-flex align-items-center">
                            <span class="dot-azul"></span>
                            <span>
                                Pasillo: No se muestra la butaca, pero se respeta su hueco (Siguiendo con la numeración)
                            </span>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-12 d-flex align-items-center">
                            <span class="dot-rojo"></span>
                            <span>
                                Pasillo: No se muestra la butaca, pero se respeta su hueco (Saltando la numeración)
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3" v-if="Object.keys(filas_resultado).length != 0">
                <div class="col-12">
                    <h1>Resultado</h1>
                </div>
                <div class="col-12">
                    <TerrenoJuegoComponent :direccion_campo="zona.direccion_campo" />

                    <div class="container-butacas-wrapper" v-if="!loading_resultado">
                        <div :class="'container-butacas text-align-' + zona.print_align">
                            <span v-for="(butacas, fila) in filas_resultado" :key="fila">
                                <span class="fila">{{ fila }}</span>
                                <AsientoComponent v-for="(asiento, index) in butacas" :asiento="asiento" :fila="fila"
                                                  :key="index + '_2'"
                                />
                                <br />
                            </span>
                        </div>
                    </div>
                    <div v-else>
                        <LoaderComponent/>
                    </div>
                </div>
            </div>
            <div class="row" v-if="zona.ocultos.length > 0">
                <div class="col-12">
                    <h1>Listado de butacas ocultas</h1>
                </div>
                <div class="col-12">
                    <ul class="list-group">
                        <li v-for="oculto in zona.ocultos" :key="oculto.id" class="list-group-item">
                            <b>Fila:</b> {{ oculto.row }} /
                            <b>Asiento:</b> {{ oculto.seat }} /
                            <b>Modo:</b>
                            <div class="mx-3" v-if="oculto.mode == 1"
                                 style="background-color: #d2d3d4; width: 30px; height: 30px; display: inline-block"
                            >
                            </div>
                            <div class="mx-3" v-if="oculto.mode == 2"
                                 style="background-color: #343deb; width: 30px; height: 30px; display: inline-block"
                            >
                            </div>
                            <div class="mx-3" v-if="oculto.mode == 3"
                                 style="background-color: #b30202; width: 30px; height: 30px; display: inline-block"
                            >
                            </div>
                            <button class="btn" @click="toggleSeleccion(oculto.row, oculto.seat)">Borrar</button>
                        </li>
                    </ul>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import CleSvgComponent from '@/components/backend/stepper/components/CleSvgComponent';
    import AsientoComponent from "../../../components/backend/stepper/components/AsientoComponent";
    import TerrenoJuegoComponent from '../../../components/common/Asientos/TerrenoJuegoComponent.vue';
    import TablaSectoresComponent from '@/components/backend/stepper/components/TablaSectoresComponent.vue';

    export default {
        data() {
            return {
                places: [],
                place: null,
                zonas: [],
                loading_zonas: false,
                loading_butacas: false,
                zona: null,
                filas: [],
                filas_resultado: {},
                seats: [],
                mode: 1,
                loading_resultado: false,
                toggleMode: null,
                butacasSeleccionadas: [],
                mapAsientos: new Map()
            }
        },
        created() {
            this.getPlaces();
        },
        watch: {
            place() {
                this.getZonas(this.place.id);
            }
        },
        computed: {
            modeString() {
                switch (this.mode) {
                    case 1:
                        return 'oculta';
                    case 2:
                        return 'con-numeracion';
                    case 3:
                        return 'sin-numeracion';
                    case 4:
                        return 'butaca-libre';
                    default:
                        return 'oculta';
                }
            }
        },
        methods: {
            cambiarModo(modo) {
                this.mode = modo;
            },
            getPlaces() {
                this.$store.dispatch(this.config.getVuexAlias('recintos.index')).then(res => {
                    this.places = res.data.data;
                });
            },
            getZonas(place_id) {
                this.loading_zonas = true;

                const params = {
                    filters: {
                        place_id: place_id
                    }
                };
                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.zonas = res.data;
                    this.loading_zonas = false;
                });
            },
            irAZona(paso, zona) {
                this.getZona(zona.id);
            },
            selectZonaTable(paso, zona) {
                this.getZona(zona.id);
                this.zona = zona;
            },
            getZona(id) {
                this.loading_butacas = true;
                const params = {
                    filters: {
                        zona_id: id,
                        conf: 0,
                        hidden_seats: 1
                    },
                };

                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.zona = res.data;
                    this.filas = res.data.configuracion_asientos;
                    this.loading_butacas = false;

                    setTimeout(() => {
                        this.initializeGrid();
                        this.initializeMapAsientos();
                    }, 10);
                });
            },
            getZonaResultado(id) {
                this.loading_resultado = true;
                const params = {
                    filters: {
                        zona_id: id,
                        conf: 0
                    },
                };

                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.filas_resultado = res.data.configuracion_asientos;
                    this.loading_resultado = false;
                });
            },
            initializeGrid() {
                const grid = document.getElementById("container-butacas");
                let isSelecting = false;
                let startX, startY, hasDragged = false;
                let affectedElements = new Set();

                grid.addEventListener("mousedown", e => {
                    if (e.button !== 0 || !e.target.classList.contains("ocultarButaca")) return;
                    const item = e.target;
                    hasDragged = false;
                    affectedElements.clear();

                    if (!e.shiftKey) {
                        document.querySelectorAll(".ocultarButaca").forEach(el => {
                            el.classList.remove(this.modeString);
                            this.mapAsientos.get(el.id).modo = null;
                        });
                    }

                    this.toggleMode = !item.classList.contains(this.modeString);

                    isSelecting = true;
                    startX = e.pageX;
                    startY = e.pageY;

                    this.toggleItem(item);
                    affectedElements.add(item);
                });

                document.addEventListener("mousemove", e => {
                    if (!isSelecting) return;
                    hasDragged = true;

                    let currentX = e.pageX;
                    let currentY = e.pageY;

                    let x1 = Math.min(startX, currentX);
                    let y1 = Math.min(startY, currentY);
                    let x2 = Math.max(startX, currentX);
                    let y2 = Math.max(startY, currentY);

                    document.querySelectorAll(".ocultarButaca").forEach(item => {
                        let rect = item.getBoundingClientRect();
                        let itemX = rect.left + window.scrollX;
                        let itemY = rect.top + window.scrollY;

                        let inside = (
                            itemX + rect.width >= x1 &&
                            itemY + rect.height >= y1 &&
                            itemX <= x2 &&
                            itemY <= y2
                        );

                        if (inside && !affectedElements.has(item)) {
                            this.toggleItem(item);
                            affectedElements.add(item);
                        }
                    });
                });

                document.addEventListener("mouseup", () => {
                    isSelecting = false;
                    this.toggleMode = null;
                    affectedElements.clear();
                });
            },
            toggleItem(item) {
                item.classList.remove("oculta");
                item.classList.remove("con-numeracion");
                item.classList.remove("sin-numeracion");
                item.classList.remove("butaca-libre");

                this.mapAsientos.get(item.id).modo = null;

                if (this.toggleMode) {
                    this.mapAsientos.get(item.id).modo = this.mode;
                    item.classList.add(this.modeString);
                } else {
                    item.classList.remove(this.modeString);
                }
            },
            initializeMapAsientos() {
                Object.keys(this.filas).forEach(fila => {
                    this.filas[fila].forEach(asiento => {
                        asiento.fila = fila;
                        const idUnico = `F${fila}-A${asiento.asiento}`;
                        this.mapAsientos.set(idUnico, asiento);
                    });
                });
            },
            ocultarButacas() {
                const butacas = [];
                this.mapAsientos.forEach((asiento, idUnico) => {
                    if (asiento.modo) {
                        butacas.push({
                            fila: asiento.fila,
                            asiento: asiento.asiento,
                            modo: asiento.modo
                        });
                    }
                });

                const params = {
                    filters: {},
                    zona_id: this.zona.id,
                    butacas: butacas
                };

                this.$store.dispatch(this.config.getVuexAlias('zonas.ocultar.butacas'), params).then(res => {
                    this.getZona(this.zona.id);
                    this.getZonaResultado(this.zona.id);
                });
            },
            toggleSeleccion : function(fila, asiento, anadir, puede_cambiar) {
                const params = {
                    filters: {
                        zona_id: this.zona.id,
                        fila: fila,
                        asiento: asiento,
                        mode: this.mode
                    },
                    zona_id: this.zona.id,
                    fila: fila,
                    asiento: asiento,
                    mode: this.mode
                };

                this.$store.dispatch(this.config.getVuexAlias('zonas.ocultar.butaca'), params).then(res => {
                    for(var i in this.filas[fila]) {
                        if(this.filas[fila][i].asiento == asiento) {
                            this.filas[fila][i].oculto = parseInt(res.data.oculta);
                        }
                    }

                    if(this.zona.ocultos.length == 0) {
                        this.zona.ocultos.push({
                            row: fila,
                            seat: asiento,
                            mode: res.data.oculta,
                            region_id: this.zona.id
                        });
                    } else {
                        for (var j in this.zona.ocultos) {
                            if(this.zona.ocultos[j].row == fila && this.zona.ocultos[j].seat == asiento) {
                                if(res.data.oculta == 0) {
                                    this.zona.ocultos.splice(j, 1);
                                    break;
                                }
                            } else {
                                if(parseInt(res.data.oculta) > 0) {
                                    this.zona.ocultos.push({
                                        row: fila,
                                        seat: asiento,
                                        mode: res.data.oculta,
                                        region_id: this.zona.id
                                    });
                                    break;
                                }
                            }
                        }
                    }
                });
            },
        },
        components: {
            CleSvgComponent, AsientoComponent, TerrenoJuegoComponent, TablaSectoresComponent
        }
    }
</script>

<style scoped>
.multiselect--active {
    z-index: 4;
}

.dot-gris {
    height: 25px;
    width: 25px;
    background-color: #d2d3d4;
    border-radius: 50%;
    display: inline-block;
    margin-right: 7px;
}

.dot-azul {
    height: 25px;
    width: 25px;
    background-color: #343deb;
    border-radius: 50%;
    display: inline-block;
    margin-right: 7px;
}

.dot-rojo {
    height: 25px;
    width: 25px;
    background-color: #b30202;
    border-radius: 50%;
    display: inline-block;
    margin-right: 7px;
}

.nav-pills .nav-item .nav-link.active-red {
    background-color: #b30202;
    color: white;
}

.nav-pills .nav-item .nav-link.active-gray {
    background-color: #a1a1a1;
    color: black;
}

.nav-pills .nav-item .nav-link.active-blue {
    background-color: #343deb;
    color: white;
}

.nav-pills .nav-item .nav-link.active-green {
    background-color: rgb(169, 209, 146);
    color: black;
}   

.oculta {
    background-color: #d2d3d4 !important;
    color: black !important;
}

.con-numeracion {
    background-color: #343deb !important;
    color: white !important;
}

.sin-numeracion {
    background-color: #b30202 !important;
    color: white !important;
}

.butaca-libre {
    background-color: #a9d192 !important;
    color: #333333 !important;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
</style>